/* eslint-disable eol-last */
import LoginView from '@strongio/pretrained-dashboard/views/logistration/login';

export default LoginView;